/** Google Drive mark (from docs/google-drive_bw.svg). */
export const GoogleDriveBwIcon = () => (
  <svg
    className="drive-sync-button__drive-icon"
    viewBox="0 -20 457.33333 457"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    focusable="false"
  >
    <path
      fill="currentColor"
      d="m158.933594 256.167969h286.265625v21.332031h-286.265625zm0 0"
    />
    <path
      fill="currentColor"
      d="m375.601562 416.167969h-293.867187l-81.734375-149.335938 146.535156-266.664062h164.265625l146.53125 266.664062zm-281.066406-21.335938h268.398438l70.132812-128-134.933594-245.332031h-138.933593l-134.933594 245.332031zm0 0"
    />
    <path
      fill="currentColor"
      d="m78.542969 400.703125 135.996093-265.757813 18.992188 9.714844-135.996094 265.761719zm0 0"
    />
    <path
      fill="currentColor"
      d="m143.792969 15.859375 18.691406-10.277344 140.769531 256.054688-18.695312 10.277343zm0 0"
    />
  </svg>
);
